import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import CmsPageForm from './CmsPageForm';
import WeddingInfoForm from './entities/WeddingInfoForm';
import HomePageAccordion from '../../../components/common/ui/homepageAccordion';
import WebsitePreview from './WebsitePreview';
import WebsitePreviewV2 from './WebsitePreviewV2';
import WeddingPartyMembers from './entities/WeddingPartyMembers';
import Faqs from './entities/Faqs';
import Pois from './entities/Pois';
import Travel from './entities/Travel';
import Registry from './entities/Registry';
import Photos from './entities/Photos';
import HomepageSections from './entities/HomepageSections';
import Events from './entities/EventsV2';
import RsvpV2 from './entities/RsvpV2';
import Accordion from '../../common/ui/Accordion';
import HomepageForm from './entities/HomepageForm';
import FeatureFlags from '../../../util/featureFlags';
import { activatePage } from '../../../actions/website/PageActions';

const EDIT_PAGE_COMPONENTS = {
  WEDDING_PARTY: WeddingPartyMembers,
  POI: Pois,
  FAQ: Faqs,
  TRAVEL: Travel,
  REGISTRY: Registry,
  PHOTO: Photos,
  HOME: HomepageSections,
  EVENT: Events,
  RSVP: RsvpV2
};

class EditPage extends Component {
  constructor(props) {
    super(props);
    this.routerWillLeave = this.routerWillLeave.bind(this);
    this.evaluateHomeForDirt = this.evaluateHomeForDirt.bind(this);
    this.state = {
      isHomeDirty: undefined
    };
  }
  componentDidMount() {
    const { activateCmsPage, params } = this.props;

    if (params.pageKey) {
      activateCmsPage(params.pageKey.toUpperCase());
    }
  }

  componentWillUpdate(nextProps) {
    const { activateCmsPage, params } = this.props;

    if (nextProps.params && nextProps.params.pageKey) {
      activateCmsPage(nextProps.params.pageKey.toUpperCase());
    }
    if (params.pageKey === 'home') {
      this.props.router.setRouteLeaveHook(
        this.props.routes[this.props.routes.length - 1],
        this.routerWillLeave
      );
    }
  }

  routerWillLeave() {
    const { isHomeDirty } = this.state;
    const { params } = this.props;
    if ((isHomeDirty === true && params.pageKey === 'home')) {
      return 'You have unsaved changes. Hit "Cancel" to save them or risk losing your work.';
    }
    return undefined;
  }

  evaluateHomeForDirt(dirty) {
    this.setState({
      isHomeDirty: dirty
    });
  }

  render() {
    const { page, theme } = this.props;
    const CurrentPage = page ? EDIT_PAGE_COMPONENTS[page.type] : undefined;

    const accordionItems = [
      {
        heading: 'Page Header',
        body: CmsPageForm,
        props: { page }
      }
    ];
    const homepageAccordionItems = [
      {
        heading: 'Wedding Summary',
        body: WeddingInfoForm,
        props: { page },
      },
      {
        heading: 'Page Header & Footer',
        body: HomepageForm,
        props: { page }
      }
    ];
    const s3bucket = window.location.hostname === 'localhost' || window.location.hostname === 'qa.zola.com' ? 'wedding-themes-dev' : 'wedding-themes';

    return (
      <div>
        {theme.key && (
          <Helmet
            link={[
              {
                rel: 'stylesheet',
                href: `https://fonts.googleapis.com/css?family=${theme.font_name}`
              },
              {
                rel: 'stylesheet',
                href: `https://s3.amazonaws.com/${s3bucket}/${theme.key}.css`
              }
            ]}
          />
        )}
        <div>
          {page && (
            <div className="col-xs-12 col-md-5">
              <CurrentPage useDragHandle lockAxis={'y'} />
                {page && page.type !== 'HOME' ? (
                  <Accordion items={accordionItems} />
                ) : (
                  <HomePageAccordion items={homepageAccordionItems} evaluateHomeForDirt={this.evaluateHomeForDirt} />
                )}
            </div>
          )}
          <div className="col-md-7 hidden-sm hidden-xs">
            {FeatureFlags.get('webPreviewRefactor') ? (
              <WebsitePreviewV2 />
            ) : (
              <WebsitePreview />
            )}
          </div>
        </div>
      </div>
    );
  }
}

EditPage.propTypes = {
  page: PropTypes.shape({}),
  activateCmsPage: PropTypes.func.isRequired,
  params: PropTypes.shape({
    pageKey: PropTypes.string
  }),
  theme: PropTypes.shape({ key: PropTypes.string, font_name: PropTypes.string }),
  router: PropTypes.shape({
    setRouteLeaveHook: PropTypes.func
  }),
  routes: PropTypes.arrayOf(PropTypes.shape({})),
};

const mapStateToProps = (state, ownProps) => {
  const { byId, typeToId, orderedIds } = state.website.pages;

  let page;
  if (ownProps.params.pageKey && typeToId[ownProps.params.pageKey.toUpperCase()]) {
    page = byId[typeToId[ownProps.params.pageKey.toUpperCase()]];
  } else if (orderedIds) {
    page = byId[orderedIds[0]];
  }

  return {
    page,
    theme: state.wedding.theme
  };
};

const mapDispatchToProps = dispatch => ({
  activateCmsPage: pageKey => dispatch(activatePage(pageKey))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPage);



// WEBPACK FOOTER //
// ./src/components/manage/website/EditPage.jsx